"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProgressBarCountdown;

var _react = _interopRequireWildcard(require("react"));

var _ProgressBarCountdownModule = _interopRequireDefault(require("./ProgressBarCountdown.module.scss"));

var _ProgressBar = _interopRequireDefault(require("../ProgressBar/ProgressBar"));

var _pad = _interopRequireDefault(require("../pad"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function isCloseToFin(secsLeft) {
  if (secsLeft <= 0 || secsLeft <= 60) {
    return true;
  }

  return false;
}

function ProgressBarCountdown(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "default" : _ref$type,
      children = _ref.children,
      endDate = _ref.endDate,
      startDate = _ref.startDate,
      _ref$showCountdown = _ref.showCountdown,
      showCountdown = _ref$showCountdown === void 0 ? true : _ref$showCountdown,
      _ref$showPerc = _ref.showPerc,
      showPerc = _ref$showPerc === void 0 ? true : _ref$showPerc,
      _ref$showDays = _ref.showDays,
      showDays = _ref$showDays === void 0 ? true : _ref$showDays,
      _ref$showMs = _ref.showMs,
      showMs = _ref$showMs === void 0 ? false : _ref$showMs,
      _ref$isOverflowing = _ref.isOverflowing,
      isOverflowing = _ref$isOverflowing === void 0 ? false : _ref$isOverflowing,
      className = _ref.className,
      style = _ref.style;

  var _useState = (0, _react.useState)(startDate || new Date()),
      _useState2 = _slicedToArray(_useState, 1),
      start = _useState2[0];

  var _useState3 = (0, _react.useState)(new Date()),
      _useState4 = _slicedToArray(_useState3, 2),
      now = _useState4[0],
      setNow = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFinished = _useState6[0],
      setIsFinished = _useState6[1];

  var deltaNowFin = endDate.getTime() - now.getTime();
  if (!isOverflowing && deltaNowFin <= 0) deltaNowFin = 0;
  var totalSecsLeft = now.getTime() - start.getTime() + deltaNowFin;
  var perc = totalSecsLeft <= 0 ? 100 : Math.ceil(100 - deltaNowFin * (100 / totalSecsLeft));
  var days = Math.floor(deltaNowFin / (1000 * 60 * 60 * 24));
  var hours = Math.floor(deltaNowFin / (1000 * 60 * 60) % 24);
  var mins = Math.floor(deltaNowFin / 1000 / 60 % 60);
  var secs = Math.floor(deltaNowFin / 1000 % 60);
  var msecs = Math.floor(deltaNowFin / 10 % 100);
  (0, _react.useEffect)(function () {
    setIsFinished(now.getTime() >= endDate.getTime());
    var interval = setInterval(function () {
      setIsFinished(now.getTime() >= endDate.getTime());
      if (!isFinished || isOverflowing) setNow(new Date());
    }, showMs ? 100 : 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [start, now, isFinished, endDate, showMs, isOverflowing]);
  return /*#__PURE__*/_react.default.createElement(_ProgressBar.default, {
    type: type,
    filledPerc: perc,
    isBlinking: isCloseToFin(totalSecsLeft),
    className: className,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarCountdownModule.default.content
  }, children && /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarCountdownModule.default.children
  }, children), showCountdown && /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarCountdownModule.default.countdown
  }, showDays && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarCountdownModule.default.days
  }, (0, _pad.default)(days.toString()), "d"), " :"), /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarCountdownModule.default.hours
  }, (0, _pad.default)(hours.toString()), "h"), ":", /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarCountdownModule.default.mins
  }, (0, _pad.default)(mins.toString()), "m"), /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarCountdownModule.default.secs
  }, (0, _pad.default)(secs.toString()), "s"), showMs && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ":", /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarCountdownModule.default.msecs
  }, (0, _pad.default)(msecs.toString()), "ms"))), showPerc && /*#__PURE__*/_react.default.createElement("div", {
    className: _ProgressBarCountdownModule.default.perc
  }, "( ", (0, _pad.default)(perc.toString(), 3), " % )")));
}